import { user } from '@/services/'
import menuFunctionalities from '@/helpers/menuFunctionalities'

const getFunctionalities = async () => {
  const { functionalities } = await user.getUserData()
  return functionalities
}

const getPermissionFromMenu = path => {
  return menuFunctionalities.find(item => item.path === path)?.permission || ''
}

export const getFirstRouteFromPermissions = async () => {
  const functionalities = await getFunctionalities()

  let path

  menuFunctionalities.map(item => {
    if (functionalities && item.permission === functionalities[0]) {
      path = item.path
    }
  })

  return path
}

export const hasPermissionToRoute = async (path) => {
  const functionalities = await getFunctionalities()
  return functionalities != null && functionalities?.includes(getPermissionFromMenu(path))
}

export default { hasPermissionToRoute, getFirstRouteFromPermissions }
